import React from "react";
import "./Wait.css";
import { LogoSpinner } from "./Loading";

type Props = {
  message: string;
};

export default function Wait({ message }: Props) {
  return (
    <div className="App">
      <div className="App-header">
        {/* <img src={logo} className="App-logo" alt="logo" /> */}
        <LogoSpinner style={{ width: "40vmin", height: "40vmin", transform: "none" }} />
        <p>{message}</p>
        <a
          className="App-link"
          href="https://formulatrix.com/protein-crystallization-systems/rock-imager-crystallization-imagers/"
          target="_blank"
          rel="noopener noreferrer"
        >
          ROCK IMAGER
        </a>
      </div>
    </div>
  );
}
